import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { EmailNotification } from 'src/app/models/notifications';


@Injectable()
export class NotificationsService {
    apiUrl = 'api/notifications';

    httpOptions = {
        headers: new HttpHeaders({
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache'
        })
    };

    constructor(
        private httpClient: HttpClient,
    ) {
    }

    getNotifications(): Observable<any> {
        return this.httpClient.get(this.apiUrl, this.httpOptions);
    }

    updateNotification(notification: EmailNotification): Observable<any> {
        return this.httpClient.post(this.apiUrl, notification, this.httpOptions);
    }

    updateNotificationActive(notification: EmailNotification): Observable<any> {
        return this.httpClient.post(this.apiUrl + '/updateActive', notification, this.httpOptions);
    }
}
